import { Box } from "@mui/material";
import { useQueries } from "@tanstack/react-query";
import useAPI from "../../../../../api/hooks/useAPI";
import { controlKeys, entityKeys } from "../../../../../api/queryKeys";
import LoadingIcon from "../../../../../components/LoadingIcon";

import { isComplexEntityType } from "../../../../../utils/utils";
import GroupedControlEntitiesSection from "./groupedControl/GroupedControlEntitiesSection";
import NonGroupedControlEntitiesSection from "./nonGroupedControl/NonGroupedControlEntitiesSection";

const anyComplexMisconfigurationInControl = (fullControl) => {
  const misconfigurationEntityTypes = fullControl.misconfigurations.map(
    (misconfiguration) => misconfiguration.entity_type
  );
  return misconfigurationEntityTypes.some((type) => isComplexEntityType(type));
};

export default function ControlEntitiesSection({
  fullControl,
  showDetailedAffectedEntities,
  setShowDetailedAffectedEntities,
  scrollDown = null,
  defaultCollapsed = false,
}) {
  const {
    getAllComplexMisconfiguredEntitiesForControl,
    getTerminatedUsersAndHosts,
  } = useAPI();

  const queries = useQueries({
    queries: [
      {
        queryKey: controlKeys.controlMisconfiguredEntities(
          fullControl.control_id
        ),
        queryFn: async () => {
          if (
            fullControl.is_grouped &&
            !anyComplexMisconfigurationInControl(fullControl)
          ) {
            return { data: {} };
          }
          return await getAllComplexMisconfiguredEntitiesForControl(
            fullControl.control_id
          );
        },

        select: (response) => response?.data,
      },
      {
        queryKey: entityKeys.terminatedEntities(),
        queryFn: getTerminatedUsersAndHosts,

        select: (response) => response?.data,
      },
    ],
  });

  const isLoading = queries.some((query) => query.isLoading);
  const isSuccess = queries.every((query) => query.isSuccess);
  const [complexEntitiesByTypeQuery] = queries;

  return (
    <Box display="flex" width="100%" flexDirection="column" gap={3}>
      {fullControl.is_grouped ? (
        <>
          {isLoading ? (
            <LoadingIcon size={10} />
          ) : isSuccess ? (
            <GroupedControlEntitiesSection
              fullControl={fullControl}
              misconfiguredComplexEntitiesByType={
                complexEntitiesByTypeQuery.data
              }
              showDetailedAffectedEntities={showDetailedAffectedEntities}
              setShowDetailedAffectedEntities={setShowDetailedAffectedEntities}
              scrollDown={scrollDown}
              defaultCollapsed={defaultCollapsed}
            />
          ) : (
            "Error loading this content..."
          )}
        </>
      ) : (
        <>
          {isLoading ? (
            <LoadingIcon size={14} />
          ) : isSuccess ? (
            <NonGroupedControlEntitiesSection
              fullControl={fullControl}
              complexEntitiesByType={complexEntitiesByTypeQuery.data}
              defaultCollapsed={defaultCollapsed}
            />
          ) : (
            "Error loading this content..."
          )}
        </>
      )}
    </Box>
  );
}
